export const DEFAULT_TASK_GROUP_PAGE_SIZE = 2;
export const DEFAULT_TASK_PAGE_SIZE = 20;
export const DEFAULT_TAKE_ALL = 999;
export const DEFAULT_CJB_TAKE_SMALL = 10;
export const DEFAULT_CJB_TAKE_LARGE = 20;
